import { render, staticRenderFns } from "./mian.vue?vue&type=template&id=bd1c9c38&scoped=true"
import script from "./mian.vue?vue&type=script&lang=ts"
export * from "./mian.vue?vue&type=script&lang=ts"
import style0 from "./mian.vue?vue&type=style&index=0&id=bd1c9c38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1c9c38",
  null
  
)

export default component.exports